export class GameSceneEvents
{
    static TOOLTIP_ON: string = 'GameSceneEvents.TOOLTIP_ON';
    static TOOLTIP_OFF: string = 'GameSceneEvents.TOOLTIP_OFF';
}
